import { useState } from 'react';
import { Button, Text, VideoDialog } from 'shell/components';

const VideoDialogDemo = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Text variant={'sh1'}>VideoDialog</Text>
            <Button onClick={() => setIsOpen(true)}>Open Video Dialog</Button>
            <VideoDialog open={isOpen} videoId={'dQw4w9WgXcQ'} onClose={() => setIsOpen(false)} />
        </>
    );
};

export default VideoDialogDemo;
